import {useState,useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'

import {
	useDeleteEvent,
	useSetViewer,
	useSetEditor,
	useViewer
} from './hooks'

import {
	makeGoogleCalendarUrl,
	makeOutlookCalendarUrl,
	makeICSCalendarUrl,
	makeTime,
	createLink,
	mapToDays
} from './util'

import {editCalendarEvent} from './slice'

import WorkoutPreview from '../WorkoutPreview/WorkoutPreview'
import NutritionPreview from '../NutritionPreview/NutritionPreview'

import Select from 'react-select'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import InputGroup from 'react-bootstrap/InputGroup'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'

import DatePicker from 'react-datepicker'
import TimePicker from '../TimePicker/TimePicker'
import LocaleDate from '../LocaleDate/LocaleDate'

import {Link} from 'react-router-dom'

import {useGymTrainers,useClients} from '../users/hooks'
import useCurrentUser from '../../hooks/useCurrentUser'
import { selectTrainerParam } from '../users/usersSlice'

import {dateToTimeObj,getTimeString,dateToYMD} from '../../util/datetime'

import {envAwarePost,capitalize} from '../../util/util'

import {
    updateCopy,
} from '../../state/events'

const eventTypeToPrintSelector = type => (
	['workout', 'task'].includes(type) ? `${capitalize(type)}s` : capitalize(type)
)

const Workout = ({id})=>{
	const [workout,setWorkout] = useState(null)
	const [isLoading,setIsLoading] = useState(true)
	const [showPreview,setShowPreview] = useState(false)
	useEffect(()=>{
		envAwarePost('/api/events/',{
			action:'getEventDetails',
			event_type:'workout',
			event_id:id
		}).then(res=>{
			setWorkout(res.data)
			setIsLoading(false)
		})
	},[])
	
	return (
		<div>
			<Button disabled={isLoading} onClick={setShowPreview.bind(null,p=>!p)} variant="outline-dark" size="sm">
				{!showPreview?'View':'Hide'} Preview
				{isLoading&&<Spinner animation="border" size="sm" className="ml-1"/>}
			</Button>
			{showPreview&&<WorkoutPreview workout={workout}/>}
		</div>
	)
}

const Nutrition = ({id})=>{
	const [nutrition,setNutrition] = useState(null)
	const [isLoading,setIsLoading] = useState(true)
	const [showPreview,setShowPreview] = useState(false)
	useEffect(()=>{
		envAwarePost('/api/events/',{
			action:'getEventDetails',
			event_type:'nutrition',
			event_id:id
		}).then(res=>{
			setNutrition(res.data)
			setIsLoading(false)
		})
	},[])
	
	return (
		<div>
			<Button disabled={isLoading} onClick={setShowPreview.bind(null,p=>!p)} variant="outline-dark" size="sm">
				{!showPreview?'View':'Hide'} Preview
				{isLoading&&<Spinner animation="border" size="sm" className="ml-1"/>}
			</Button>
			{showPreview&&<NutritionPreview nutrition={nutrition}/>}
		</div>
	)
}

const Task = ({id})=>{
	const [task,setTask] = useState(null)
	const [isLoading,setIsLoading] = useState(true)
	useEffect(()=>{
		envAwarePost('/api/events/',{
			action:'getEventDetails',
			event_type:'task',
			event_id:id
		}).then(res=>{
			console.log(res)
			setTask(res.data)
			setIsLoading(false)
		})
	},[])
	
	return (
		<div>
			{isLoading&&<Spinner animation="border" size="sm"/>}
			{!isLoading&&
				task.notes
			}
		</div>
	)
}

const EventDetails = ({event})=>{
	switch(event.event_type){
		case "workout": return <Workout id={event.event_id}/>
		case "nutrition": return <Nutrition id={event.event_id}/>
		case "task": return <Task id={event.event_id}/>
		default: return (
			Boolean(event.body)&&
			<div>
				<i className="fa fa-info-circle mr-2"/>
				{event.body}
			</div>	
		)
	}
}

export default function () {
	const dispatch = useDispatch()

	const {show,event} = useViewer()

	const trainerParam = useSelector(selectTrainerParam)

	const isRecurring = (
		event?.recurrence_type !== ''
		&& event?.recurrence_type !== 'none'
	)

	const isRequest = (
		parseInt(event?.status) === 0
	)

	//Workout, task, nutrition.....
	const isEvent = ['workout','task','nutrition'].includes(event?.event_type)

	const setViewer = useSetViewer()
	const setEditor = useSetEditor()

	const {status:trainersStatus,entities:trainerMap} = useGymTrainers()
	const {status:clientsStatus,entities:clientMap} = useClients()

	const time = {start:{},end:{}}
	const date = event?.occurrence_date

	const onHide = ()=>{
		dispatch(setViewer({
			show:false,
			date:null,
			time:{start:{},end:{}}
		}))
	}

	const handleEditSeries = ()=>{
		setViewer({
			show:false,
			id:null
		})
		setEditor({
			show:true,
			id:event.id,
			editSeries:true
		})
	}

	const handleEditSingle = ()=>{
		setViewer({
			show:false,
			id:null
		})
		setEditor({
			show:true,
			id:event.id,
			editSeries:false,
			date:event.occurrence_date
		})
	}


	const deleteEvent = useDeleteEvent()
	
	const handleDeleteSeries = ()=>{
		onHide()
		const payload = {
			edit_series: 1,
			event_type: event.event_type,
			event_id: event.calendar_id,
		}
		deleteEvent(payload)
	}

	const handleDeleteSingle = ()=>{
		onHide()
		const payload = {
			edit_series: 0,
			event_type: event.event_type,
			event_id: event.calendar_id,
			occurrence_id:event.id,
			old_start_date: `${event.occurrence_date} ${event.start_time}`
		}
		deleteEvent(payload)
	}

	const [isSaving,setIsSaving] = useState(false)

	const handleAcceptSeries = ()=>{
		setIsSaving(true)
		//remove params that will cause API issues
		//because legacy... 
		const {trainer,...noConflict} = event
		const payload = {
			action:'editCalendarEvent',
			...noConflict,
			//so much legacy...
			event_id:event.calendar_id,
			edit_series:1,
			status:'',
		}
		console.log(payload)

		dispatch(editCalendarEvent(payload)).then(res=>{
			setIsSaving(false)
			onHide()
		})
	}

	const handleAcceptSingle = ()=>{
		setIsSaving(true)
		//remove params that will cause API issues
		//because legacy... 
		const {trainer,...noConflict} = event
		const payload = {
			action:'editCalendarEvent',
			...noConflict,
			start_date:`${event.occurrence_date} ${event.start_time}`,
			end_date:`${event.occurrence_date} ${event.end_time}`,
			//so much legacy...
			event_id:event.calendar_id,
			old_start_date:`${event.occurrence_date} ${event.start_time}`,
			edit_series:0,
			status:'',
		}
		console.log(payload)

		dispatch(editCalendarEvent(payload)).then(res=>{
			setIsSaving(false)
			onHide()
		})
	}

	const handleDeclineSeries = ()=>{
		setIsSaving(true)
		//remove params that will cause API issues
		//because legacy... 
		const {trainer,...noConflict} = event
		const payload = {
			action:'editCalendarEvent',
			...noConflict,
			//so much legacy...
			event_id:event.calendar_id,
			edit_series:1,
			status:2,
		}
		console.log(payload)

		dispatch(editCalendarEvent(payload)).then(res=>{
			setIsSaving(false)
			onHide()
		})
	}

	const handleDeclineSingle = ()=>{
		setIsSaving(true)
		//remove params that will cause API issues
		//because legacy... 
		const {trainer,...noConflict} = event
		const payload = {
			action:'editCalendarEvent',
			...noConflict,
			start_date:`${event.occurrence_date} ${event.start_time}`,
			end_date:`${event.occurrence_date} ${event.end_time}`,
			//so much legacy...
			event_id:event.calendar_id,
			old_start_date:`${event.occurrence_date} ${event.start_time}`,
			edit_series:0,
			status:2,
		}
		console.log(payload)

		dispatch(editCalendarEvent(payload)).then(res=>{
			setIsSaving(false)
			onHide()
		})
	}

	const handleCopyEvent = ()=>{
		onHide()
		dispatch(updateCopy({
			show: true,
			type: event.event_type,
			id: event.event_id
		}))
	}

	function handleCreateLink(type) {
		if (!event) return ''
        const calendarEvent = {
            name: event.text,
            location: '',
            details: event.body,
            startsAt: event.start_date,
            endsAt: `${event.start_date.split(' ')[0]} ${event.end_time}`,
        }

        const repeatType = event.recurrence_type
        if(Boolean(repeatType)){
            const interval = event?.repeat_frequency
            const repeatWeekDays = mapToDays(event.week_days)

        

            if (repeatType === 'day') {
                calendarEvent.rrule = `RRULE:FREQ=DAILY;INTERVAL=${interval};UNTIL=${makeTime(event.end_date)}`
            } else if (repeatType == "week") {
                const standardizedWeekDay = repeatWeekDays.map(item => (item.slice(0, 2)))
                const byDay = standardizedWeekDay.join(",").toUpperCase();
                calendarEvent.rrule = `RRULE:FREQ=WEEKLY;INTERVAL=${interval};WKST=MO;BYDAY=${byDay};UNTIL=${makeTime(event.end_date)}`
            }
        }

        if(type==='google'){
            return makeGoogleCalendarUrl(calendarEvent)
        }
        if(type==='ics'){
            return makeICSCalendarUrl(calendarEvent)
        }
        if(type==='outlook'){
            return makeOutlookCalendarUrl(calendarEvent)
        }
    }

    const eventTypeText = (()=>{
    	const customTypes = ['semi_private','group_session']
    	if(customTypes.includes(event.event_type)){
    		switch(event.event_type){
    			case 'semi_private': return 'Semi-private training session'
    			case 'group_session': return 'Class'
    		}
    	}
    	else {
    		return event.event_type
    	}
    })()
	

	if (!Boolean(event)) return null

	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header className="d-flex justify-content-between flex-wrap">
				<span>
					<strong>{event.title}</strong>
					{isRequest&&
						<span className="ml-1">(request)</span>
					}
				</span>
				<LocaleDate date={new Date(`${event.occurrence_date}T00:00:00`)} includeTime={false} includeYear={false}/>
			</Modal.Header>
			<Modal.Body>
				<div>
					<i className="fa fa-toolbox mr-2"/>
					{eventTypeText}
				</div>
				<EventDetails event={event}/>
				{event.trainers.length>0&&
					<div>
						<i className="fa fa-user mr-2"/>
						{event.trainers.map(({user_name})=>user_name).join(', ')}
					</div>
				}
				{event.client_id_arr.length>0&&
					<div>
						<i className="fa fa-users mr-2"/>
						{event.client_id_arr.map(id=>clientMap[id]?.user_name).join(', ')}
					</div>
				}
				<div className="mt-3 d-flex align-items-center">
					<i className="fas fa-inbox mr-2 "></i>
					<OverlayTrigger overlay={
						<Tooltip>Add to google calendar</Tooltip>
					}>
						<a className="btn btn-sm mr-2 btn-outline-primary" href={handleCreateLink('google')} target="_blank">
							<i className="fab fa-google"> </i>
						</a>
					</OverlayTrigger>
					<OverlayTrigger overlay={
						<Tooltip>Download to calendar app</Tooltip>
					}>
						<a className="btn btn-sm mr-2 btn-outline-primary" href={handleCreateLink('ics')} target="_blank">
							<i className="fab fa-apple"></i>
								<span className="mx-2">/</span>
							<i className="fab fa-microsoft"></i>
						</a>
					</OverlayTrigger>
				</div>
				{(isRequest&&!isRecurring&&!isEvent)&&
					<div className="d-flex justify-content-between mt-2">
						<Button 
							onClick={handleDeclineSeries} 
							variant="outline-danger"
							disabled={isSaving}
						>
							Decline
						</Button>
						<Button 
							onClick={handleAcceptSeries} 
							variant="outline-success"
							disabled={isSaving}
						>
							Accept
							{isSaving&&<Spinner animation="border" size="sm" className="ml-1"/>}
						</Button>
						<Button 
							onClick={handleEditSeries} 
							variant="outline-primary"
							disabled={isSaving}
						>
							Edit
						</Button>
					</div>
				}
				{(isRequest&&isRecurring&&!isEvent)&&
					<div className="d-flex justify-content-between mt-2 align-items-end">
						<div>
							<div>
								Decline
							</div>
							<ButtonGroup>
								<OverlayTrigger overlay={
									<Tooltip>Decline the entire series of requested sessions</Tooltip>
								}>
									<Button 
										onClick={handleDeclineSeries} 
										variant="outline-danger"
										disabled={isSaving}
										 size="sm"
									>
										All
									</Button>
								</OverlayTrigger>
								<OverlayTrigger overlay={
									<Tooltip>Decline this session on <LocaleDate date={new Date(`${event.occurrence_date}T00:00:00`)} includeTime={false} includeYear={false}/></Tooltip>
								}>
									<Button 
										style={{flex:'0 0 auto'}}
										onClick={handleDeclineSingle} 
										variant="outline-danger"
										disabled={isSaving}
										 size="sm"
									>
										<LocaleDate date={new Date(`${event.occurrence_date}T00:00:00`)} includeTime={false} includeYear={false}/>
									</Button>
								</OverlayTrigger>
							</ButtonGroup>
						</div>
						<div>
							<div>
								Accept
							</div>
							<ButtonGroup>
								<OverlayTrigger overlay={
									<Tooltip>Accept the entire series of requested sessions</Tooltip>
								}>
									<Button 
										onClick={handleAcceptSeries} 
										variant="outline-success"
										disabled={isSaving}
										size="sm"
									>
										All
										{isSaving&&<Spinner animation="border" size="sm" className="ml-1"/>}
									</Button>
								</OverlayTrigger>
								<OverlayTrigger overlay={
									<Tooltip>Accept this session on <LocaleDate date={new Date(`${event.occurrence_date}T00:00:00`)} includeTime={false} includeYear={false}/></Tooltip>
								}>
									<Button 
										style={{flex:'0 0 auto'}}
										onClick={handleAcceptSingle} 
										variant="outline-success"
										disabled={isSaving}
										size="sm"
									>
										<LocaleDate date={new Date(`${event.occurrence_date}T00:00:00`)} includeTime={false} includeYear={false}/>
										{isSaving&&<Spinner animation="border" size="sm" className="ml-1"/>}
									</Button>
								</OverlayTrigger>
							</ButtonGroup>
						</div>
						<div>
							<div>
								Edit
							</div>
							<ButtonGroup>
								<OverlayTrigger overlay={
									<Tooltip>Edit the entire series of requested sessions</Tooltip>
								}>
									<Button 
										onClick={handleEditSeries} 
										variant="outline-primary"
										disabled={isSaving}
										size="sm"
									>
										All
									</Button>
								</OverlayTrigger>
								<OverlayTrigger overlay={
									<Tooltip>Edit this session on <LocaleDate date={new Date(`${event.occurrence_date}T00:00:00`)} includeTime={false} includeYear={false}/></Tooltip>
								}>
									<Button 
										onClick={handleEditSingle} 
										variant="outline-primary"
										disabled={isSaving}
										size="sm"
									>
										<LocaleDate date={new Date(`${event.occurrence_date}T00:00:00`)} includeTime={false} includeYear={false}/>
									</Button>
								</OverlayTrigger>
							</ButtonGroup>
						</div>
					</div>
				}
				{(!isRequest&&!isEvent)&&
					<div className="d-flex justify-content-between flex-wrap mt-2">
						<div>
							<div>Delete</div>
							<ButtonGroup size="sm">
								{isRecurring&&
									<Button onClick={handleDeleteSingle} variant="outline-danger">
										Selected Day
									</Button>
								}
								<Button onClick={handleDeleteSeries} variant="outline-danger">
									{isRecurring?'Entire Series':'Delete'}
								</Button>
							</ButtonGroup>
						</div>
						<div>
							<div>Edit</div>
							<ButtonGroup size="sm">
								{isRecurring&&
									<Button onClick={handleEditSingle} variant="outline-primary">
										Selected Day
									</Button>
								}
								<Button onClick={handleEditSeries} variant="outline-primary">
									{isRecurring?'Entire Series':'Edit'}
								</Button>
							</ButtonGroup>
						</div>
					</div>
				}
				{isEvent&&
					<div className="d-flex justify-content-between mt-2">
						<Button 
							onClick={handleCopyEvent}
							variant="outline-primary"
							size="sm"
						>
							Copy {capitalize(event.event_type)}
						</Button>
						<Button 
							as={Link}
							to={`/eventEditor/?event_id=${event.event_id}&event_type=AddOrEdit&eventType=${capitalize(event.event_type)}&client=${event.client_ids}&origin=myCalendar${trainerParam}`}
							variant="outline-primary"
							size="sm"
						>
							Edit {capitalize(event.event_type)}
						</Button>
						<Button 
							as={Link}
                            to={`/eventsView?display=${event.event_id}&selector=${eventTypeToPrintSelector(event.event_type)}&filter=client&client=${event.client_ids}&origin=myCalendar&view=list${trainerParam}`}
							size="sm"
						>
							View Details
						</Button>
					</div>
				}
			</Modal.Body>
		</Modal>
	)
}